// --- FRONTEND (React.js) ---

// File: src/pages/Signup.js
import React, { useState } from 'react';
import axios from 'axios';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './styles.scss';
import loginpg from '../assets/loginpage.jpg';
import finkraftLogo from '../assets/finkraftlogo.png';
import BCDLogo from '../assets/BCDTravel_Logo-FC.png';
import fk from '../assets/finkraft_logo_new.png';


const Signup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [fullName, setFullName] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [modalMessage, setModalMessage] = useState(false); // ✅ state for modal


  const validate = () => {
    const errs = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) errs.email = "Invalid email format";
    if (password.length < 6) errs.password = "Password must be at least 6 characters";
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

 
 const handleSignup = async () => {
  if (!validate()) return;
  try {
    const res = await axios.post('https://bcd-prospect-admin.finkraftai.com/api/send-otp', { email, password, fullName });
    setStep(2);
  } catch (err) {
    if (err.response && err.response.status === 400 && err.response.data.error === 'User already registered') {
      setModalMessage('This email is already registered. Please log in instead.');
    } else {
      setModalMessage('Something went wrong. Please try again.');
    }
  }
};

const handleVerify = async () => {
  const errs = {};

  // ✅ Validate OTP before API call
  if (!/^\d{6}$/.test(otp)) {
    errs.otp = "OTP must be exactly 6 digits";
    setErrors(errs);
    return;
  }

  try {
    const res = await axios.post('https://bcd-prospect-admin.finkraftai.com/api/verify-otp', { email, password, otp });

    // ✅ Success
    if (res.data.success) {
      navigate('/login');
    }
  } catch (err) {
    // ✅ Check if backend sent an "Invalid OTP" error
    if (err.response && err.response.data && err.response.data.error === "Invalid OTP") {
      setErrors({ otp: "Invalid OTP. Please try again." });
    } else {
      setErrors({ otp: "Something went wrong. Please try again." });
    }
  }
};



  return (
    <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px',paddingLeft: '90px',paddingTop: '10px' }}>
        <img src={fk} alt="Finkraft Logo" style={{ height: '50px', width: '50px' }} />
        
        {/* Divider */}
        <div style={{ width: '3px', height: '40px', backgroundColor: 'black' }}></div>
    
        <img src={BCDLogo} alt="BCD Logo" style={{ height: '55px', width: '160px', marginBottom: '15px' }} />
      
        </div>
    <div className="auth-container">
      
      {/* ✅ MODAL for duplicate email */}
      {modalMessage && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>⚠️ Notice</h3>
            <p>{modalMessage}</p>
            <button onClick={() => setModalMessage('')} className="close-btn">OK</button>
          </div>
        </div>
      )}
       <div className="auth-content">
        <div className="main-text">
          <h1>
            Welcome to the <br/><strong>Finkraft × BCD </strong><br />
            Partner Portal
          </h1>
        </div>
         <p className="desc">
             Built to help manage accounts, track lead progress, and drive mutual success.

          </p>
        <p className="footer"> Log in to stay informed, aligned, and ahead.</p>
      </div>

      <div className="auth-card">
        <h2>Create new account</h2>
        <p className="subtitle">Come join the community! Let’s set up your account.</p>

        {step === 1 && (
          <>
            <div className="form-group">
              <label htmlFor="fullname">Full Name</label>
              <input
                type="text"
                id="fullname"
                placeholder="Enter your name"
                value={fullName}
                onChange={e => setFullName(e.target.value)}
              />
              {errors.fullName && <p className="error">{errors.fullName}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              {errors.email && <p className="error">{errors.email}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-field">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </span>
              </div>
              {errors.password && <p className="error">{errors.password}</p>}
            </div>

            {/* <div className="options-row">
        <label>
          <input type="checkbox" />
          Keep me logged in
        </label>
        <a href="#">Forgot-password ?</a>
      </div> */}
          </>
        )}

        {step === 2 && (
  <div className="form-group">
    <label htmlFor="otp">Enter OTP</label>
   <input
  type="text"
  id="otp"
  placeholder="Enter 6-digit OTP"
  maxLength={6}
  value={otp}
  onChange={(e) => {
    // ✅ Only allow digits
    const value = e.target.value.replace(/\D/g, "");
    setOtp(value);
  }}
/>
{errors.otp && <p className="error">{errors.otp}</p>}
<p className="otp-hint">OTP sent to <strong>{email}</strong></p>


  </div>
)}


        <button className="submit-btn" onClick={step === 1 ? handleSignup : handleVerify}>
          {step === 1 ? 'Sign-up' : 'Verify OTP'}
        </button>

        <div className="switch-link">
          Already have account? <span onClick={() => navigate('/login')}>Sign in</span>
        </div>
      </div>

    </div>
     </div>
  );
};

export default Signup;